import { motion } from "framer-motion";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        {/* Logo ko animate karte hain */}
        <motion.img
          src="/logo192.png"
          className="App-logo"
          alt="logo"
          initial={{ scale: 0, rotate: -180, opacity: 0 }}
          animate={{ scale: 1, rotate: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
        />

        {/* Heading animated */}
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          Wheel O Wheel
        </motion.h1>

        {/* Paragraph animated */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          Premium & Bulletproof Vehicle Rentals
        </motion.p>

        {/* Button animated */}
        <motion.a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          Learn More
        </motion.a>
      </header>
    </div>
  );
}

export default App;
